import { ArrowRightIcon } from '@phosphor-icons/react';
import { Alert, Button } from '@skupreme/shared/ui';
import { useState } from 'react';
import { useNavigate } from 'react-router';

export type CatalogIssueAlertsProps = {
  missingInformation?: number;
  unmatchedListings?: number;
  readOnly?: boolean;
};

const count = (n: number, one: string, many: string) => (
  <strong className="sk:font-semibold sk:text-fg">
    {n} {n === 1 ? one : many}
  </strong>
);

/** What needs fixing in the catalog, in one strip with the way to start fixing it. */
export function CatalogIssueAlerts({
  missingInformation = 0,
  unmatchedListings = 0,
  readOnly,
}: CatalogIssueAlertsProps) {
  const navigate = useNavigate();
  // Dismissing hides these counts; new counts (another region, new issues) bring the strip back.
  const shown = `${missingInformation}:${unmatchedListings}`;
  const [dismissedAt, setDismissedAt] = useState<string | null>(null);

  if (
    dismissedAt === shown ||
    (missingInformation <= 0 && unmatchedListings <= 0)
  ) {
    return null;
  }

  const href =
    missingInformation > 0
      ? '/app/catalogs/resolve-conflict'
      : '/app/catalogs/listings/unmatched-items';

  return (
    <Alert
      tone="info"
      onDismiss={() => setDismissedAt(shown)}
      action={
        <Button
          variant="pill"
          size="sm"
          isDisabled={!!readOnly}
          onPress={() => navigate(href)}
        >
          Review
          <ArrowRightIcon size={12} weight="bold" />
        </Button>
      }
    >
      {missingInformation > 0 && (
        <span>
          {count(missingInformation, 'item', 'items')}{' '}
          {missingInformation === 1 ? 'has' : 'have'} missing information
        </span>
      )}
      {missingInformation > 0 && unmatchedListings > 0 && ' · '}
      {unmatchedListings > 0 && (
        <span>
          {count(unmatchedListings, 'listing', 'listings')}{' '}
          {unmatchedListings === 1 ? 'is' : 'are'} unmatched
        </span>
      )}
    </Alert>
  );
}
